// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"88512120","988":"20c70d65"}[chunkId] + ".chunk.js";
};